import { ShareOwnership } from '@features/ForestOwner/Search/Overview/ShareOwnership'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/$forestownerId/shareownership/')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Andelseierskap',
  },
})

function RouteComponent() {
  return <ShareOwnership />
}
